// Mother Cell home comforts (bead iu2): a gentle heal aura around her, and a
// rest state — hold still beside her and healing accelerates while your eyes
// ease shut. The bonfire of the souls loop, played as being fed by your mum.

import type { Entity } from '../components'
import type { GameWorld } from '../world'
import { motherEntity, MOTHER_HOME } from './npc'
import { T } from '../tunables'

let stillTimer = 0

export function resetMotherRest(): void {
  stillTimer = 0
}

/** True while the player is actively resting beside her (for tests/feel). */
export function isResting(): boolean {
  return stillTimer >= T.mother.restIdleSec
}

export function motherSystem(world: GameWorld, player: Entity, dt: number): void {
  const mother = motherEntity(world)
  if (!mother) return

  // She is sessile. Anything that manages to shove her (a stray impulse, a
  // future hazard) just means she drifts back to her spot and settles —
  // never leaves home, no matter what the ocean does.
  if (mother.velocity) {
    mother.velocity.x -= mother.velocity.x * 3 * dt
    mother.velocity.y -= mother.velocity.y * 3 * dt
  }
  const homeBlend = Math.min(1, 1.5 * dt)
  mother.position.x += (MOTHER_HOME.x - mother.position.x) * homeBlend
  mother.position.y += (MOTHER_HOME.y - mother.position.y) * homeBlend

  const pos = mother.position
  if (!player.health) return

  const dx = player.position.x - pos.x
  const dy = player.position.y - pos.y
  const r = T.mother.auraRadius
  if (dx * dx + dy * dy > r * r) {
    stillTimer = 0
    return
  }

  const speed = Math.hypot(player.velocity?.x ?? 0, player.velocity?.y ?? 0)
  stillTimer = speed < T.mother.restSpeedEps ? stillTimer + dt : 0

  const resting = stillTimer >= T.mother.restIdleSec
  const rate = T.mother.auraRegen * (resting ? T.mother.restRegenMult : 1)
  player.health.current = Math.min(player.health.max, player.health.current + rate * dt)

  // Resting reads on the body: eyes ease shut and stay shut until you move.
  if (resting && player.eyes) {
    player.eyes.holdClosedTimer = 0.25
  }
}
